export const annualTradesReportLocation = "/reports/sec/annualreports"